export function clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
}
export function mapRange(value, low1, high1, low2, high2) {
    return low2 + ((high2 - low2) * (value - low1)) / (high1 - low1);
}
export function capDimensions(width, height, maxPixels) {
    const pixels = width * height;
    if (pixels <= maxPixels) {
        return { width, height };
    }
    const ratio = width / height;
    const scale = Math.sqrt(pixels / maxPixels);
    const height2 = height / scale;
    const width2 = (ratio * height) / scale;
    return { width: width2, height: height2 };
}
//# sourceMappingURL=math.js.map